<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<form-query-button  @select-type="getDataList" >  </form-query-button>
					<edit-button  @select-type="getChooseDay"  :disabled="this.sels.length===0" btnCon="数据重算"></edit-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" 
            :height="formHeight"  @selection-change="selsChange"  size="small" >
            <el-table-column   type="selection"   width="55">   </el-table-column>
			<el-table-column type="index" label="序号"  ></el-table-column>
			<!-- <el-table-column prop="Date" label="MN" width="160" fixed></el-table-column> -->
			<el-table-column prop="time" label="监测时间" width="160"  sortable></el-table-column>
			<el-table-column
				v-for="item in facList"
				:prop="item.keyWord" :label="item.title" :key="item.keyWord"  min-width="150">
				<template slot-scope="scope">
					<span v-if="scope.row[item.keyWord]==null" >{{"-"}}</span>
					<!-- <span v-else-if="item.keyWord=='primarypollutant'" >{{item.keyWord}}</span> -->
					<span v-else >{{scope.row[item.keyWord]}}</span>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[ 50, 100, 200,500]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

         <el-dialog title="自选统计" :visible.sync="hourVisible" width="80%"  :close-on-click-modal="false">
            <el-button type="primary" v-on:click="exportData()" style="float: right;margin-bottom: 5px;margin-right: 10px;"  size="small" >导出</el-button>
            <el-table :data="hourdataList" border  highlight-current-row v-loading="listhourLoading" style="width: 100%;" :max-height="formHeight"   size="small" >
                <el-table-column prop="projectName" label="项目名称"  ></el-table-column>
                <el-table-column prop="siteName" label="点位名称"   ></el-table-column>
                <el-table-column prop="mn" label="设备编码"    v-if="type==0"></el-table-column>
                <el-table-column prop="starttime" label="开始时间"    ></el-table-column>
                <el-table-column prop="endtime" label="结束时间"    ></el-table-column>
                <el-table-column prop="functionalAreaName" label="功能区分类"    ></el-table-column>
                <el-table-column prop="ld" label="Ld(dB)"    ></el-table-column>
                <el-table-column prop="ln" label="Ln(dB)"    ></el-table-column>
                <el-table-column prop="ldn" label="Ldn(dB)"    ></el-table-column>
            </el-table>
		</el-dialog>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,noiseFileData,getChooseDay} from '../../api/api';
	import {formatDate,factorExcept,in_array} from '../../../static/fun.js';

	import FormQueryButton from '../../components/myButton/FormQueryButton.vue'
	import EditButton from '../../components/myButton/EditButton.vue'

	export default {
	components: { FormQueryButton ,EditButton},
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					mn:"",
					time:[]
				},
				total: 0,
				page:1,
				pageSize:50,
				listLoading: false,
                listhourLoading:false,
				dataList:[],
				firstFlag:true,
				devices:[],
				facList:[],
				projects:[],
				formHeight:0,
				dataType:'hour',

				type:sessionStorage.getItem("type"),
                sels:[],
                hourdataList:[ ],
                hourVisible:false
			}
			
		},
		methods: {
            exportData(){
                require.ensure([], () => {
                    const { export_json_to_excel } = require('vendor/Export2Excel');
                    const tHeader =  [ '项目名称','点位名称', '设备编码', '开始时间','结束时间','功能区分类', 'Ld' ,'Ln', 'Ldn' ];
                    const filterVal = ['projectName', 'siteName', 'mn','starttime','endtime','functionalAreaName','ld','ln','ldn' ];  

                    var data=[];
                    var sheetName=[];
                    data.push(this.formatJson(filterVal, this.hourdataList));
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader, data, '自选统计数据',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            getChooseDay(){
				this.hourVisible=true;
                var ids = this.sels.map(item => item.id).toString();
                let para = {
                    mn: this.filters.mn,
					ids: ids
				};
				
				this.listhourLoading = true;
                getChooseDay(para).then((res) => { 
                    this.listhourLoading = false;
                    if(res.data.result==false){
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }else{
                        this.hourdataList=[];
                        var data = res.data.data; 
                        // data.starttime=formatDate(this.filters.time[0]);
                        // data.endtime=formatDate(this.filters.time[1]);
                        this.hourdataList.push(data);
                    }
                });
            },
            selsChange: function (sels) {
				this.sels = sels;
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
			//获取历史数据信息
			getDataList(){
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
                }
				let para = {
					dataType:this.dataType,
					page: this.page,
					pageSize:this.pageSize,
                    mn: this.filters.mn,
					startDate: starttime,
                    endDate: endtime
				};
				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}
				this.listLoading = true;
				noiseFileData(para).then((res) => {
					this.listLoading = false;

					this.total = res.data.total;
					this.dataList = res.data.realDatas;

					var arr=factorExcept();
							
					if(this.dataList.length>0){
						this.facList=[];
						for (var element in this.dataList[0]) {
							if(in_array(element,arr)){
								continue
							}
							var obj=JSON.parse(sessionStorage.getItem(element));
							if(element=="aqi"){
								obj.title=obj.name;
							}else if(element=="wuranwu"){
								obj=JSON.parse(sessionStorage.getItem("primarypollutant"));
								obj.keyWord="wuranwu";
								obj.title=obj.name;
							}else if(obj.unit.trim()!=""){
								obj.title=obj.name+'('+obj.unit+')';
							}else{
								obj.title=obj.name;
							}
							this.facList.push(obj);
						}
						
					}
				});
			},
			
		
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
                start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// ChooseDay.vue?2e0459a4